import { authClient } from "@/lib/auth-client";
import { useMySubscription } from "@/hooks/queries/useMySubscription";
import { AUTO_QUALIFICATION_PLAN_NAMES } from "@/lib/domain-constants";

/**
 * Si quien mira tiene el cruce automático por línea (Comercial, Corporativo y admins):
 * marcar líneas en Documentos, el pill de la línea, el banner y los chips por
 * calificación. Lo desbloqueado se cruza en todo plan. Espeja `canAutoQualify` del backend: cambiarlos juntos.
 */
export function useCanAutoQualify(): boolean {
  const { data: session } = authClient.useSession();
  const { data: subscription } = useMySubscription();
  const isAdmin =
    (session?.user as { role?: string | null } | undefined)?.role === "admin";
  return isAdmin || AUTO_QUALIFICATION_PLAN_NAMES.includes(subscription?.planKey ?? "");
}
